export function getStepperItemQuerySelector(id: string): string {
  return `[stepperItem="${id}"]`
}
